import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { DraftAccountDTO, yesNoOpts } from '../../AccountOpening.meta';
import { EditableField } from '../../components/EditableField/EditableField';
import { SpaceProps } from '../../../../theme/styledProps';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';

const fieldName = 'isCustodianEmployee';

interface Props extends SpaceProps {
  isReview?: boolean;
  draftAccount: DraftAccountDTO;
}

export const CustodianEmployee: React.FC<Props> = ({ isReview, draftAccount, ...rest }) => {
  const formBag = useFormContext();

  const [isEditing, setIsEditing] = useState(!isReview);

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        <Text fontWeight={500}>{get(draftAccount, fieldName) ? 'Yes' : 'No'}</Text>
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            value={yesNoOpts.find(({ value }) => value === field.value)}
            label={
              isReview
                ? undefined
                : 'Is the account holder an employee of, or affiliated with, Apex Fintech Solutions?'
            }
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value);

                if (opt.value) {
                  formBag.setValue('isAffiliatedExchangeOrFINRA', false);
                }
              }
            }}
            options={yesNoOpts}
            aria-label="Is the account holder an employee of, or affiliated with, Apex Fintech Solutions?"
          />
        )}
      />
    </Box>
  );
};
